import { ResultModel } from "types/ApiResponse"
import { HistoryAO } from "types/HistoryAO"

import { request } from "../config"

const PATH_NAME = "History"

export const getHistoryAO = async (): Promise<ResultModel<HistoryAO[]>> =>
  request.get(PATH_NAME)
